import {Formatter} from './units-formatter';

const paddingZeros = (value: any): string => {
  if (value < 10) {
    return '0' + value;
  }
  return value.toString();
};

export class RaToDegFormatter extends Formatter {
  private readonly decimals = 3;

  apply(ra: string): number {
    const tokens = ra.split(':');
    let hours = +tokens[0];
    let minutes = +tokens[1];
    let seconds = +tokens[2];

    seconds = Math.floor(seconds * Math.pow(10, this.decimals) + 0.5) / Math.pow(10, this.decimals);

    while (seconds >= 60.0) {
      seconds = seconds - 60.0;
      minutes++;
    }

    while (minutes >= 60) {
      minutes = minutes - 60;
      hours++;
    }

    hours = hours % 24;

    return +((Math.abs(hours) + Math.abs(minutes) / 60.0 + Math.abs(seconds) / 3600.0) * 15.0) % 360.0;
  }
}

export class RaToHmsFormatter extends Formatter {
  apply(angle: number): string {
    const hourAngle = (angle % 360.0) / 15.0;
    const hours = Math.floor(hourAngle);
    const minutes = Math.floor((hourAngle - hours) * 60);

    let seconds = ((hourAngle - hours) * 60 - minutes) * 60;
    seconds = Math.floor(seconds * 1000.0 + 0.5) / 1000.0;

    if (Math.abs(seconds) < 0.0009) {
      seconds = 0.0;
    }

    const hoursFormatted = paddingZeros(hours);
    const minutesFormatted = paddingZeros(minutes);
    const secondsFormatted = paddingZeros(seconds.toFixed(3));

    return `${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
  }
}
